import { useNavigate } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  LogOut, Sun, Moon, HelpCircle, MessageSquare, Gift, Shield,
} from "lucide-react";

export function SidebarUserProfile({ user, theme, onToggleTheme, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className={`p-3 border-t ${theme === "light" ? "border-gray-200" : "border-white/5"}`}>
      <div className="flex items-center gap-2.5 mb-2.5">
        <Avatar className="w-9 h-9 flex-shrink-0">
          <AvatarImage src={user?.picture} />
          <AvatarFallback className="bg-emerald-700 text-white text-sm">
            {user?.name?.charAt(0) || "U"}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <div className={`text-sm font-medium truncate leading-tight ${theme === "light" ? "text-gray-900" : "text-white"}`}>{user?.name}</div>
          <div className="text-[11px] capitalize leading-tight text-gray-500">{user?.role}</div>
        </div>
        <button
          data-testid="earn-btn"
          className="earn-btn flex-shrink-0 px-2.5 py-1 rounded-full text-[10px] font-bold text-white bg-gradient-to-r from-emerald-700 to-emerald-500 flex items-center gap-1 whitespace-nowrap"
        >
          <Gift className="w-3 h-3" />
          EARN $
        </button>
      </div>

      <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] ${theme === "light" ? "text-gray-500" : "text-gray-500"}`}>
        <button className={`flex items-center gap-1 ${theme === "light" ? "hover:text-gray-900" : "hover:text-white"} transition-colors`}>
          <HelpCircle className="w-3.5 h-3.5" />
          Support
        </button>
        <button className={`flex items-center gap-1 ${theme === "light" ? "hover:text-gray-900" : "hover:text-white"} transition-colors`}>
          <MessageSquare className="w-3.5 h-3.5" />
          Community
        </button>
        <button
          data-testid="theme-toggle-btn"
          onClick={onToggleTheme}
          className={`flex items-center gap-1 ${theme === "light" ? "hover:text-gray-900" : "hover:text-white"} transition-colors`}
        >
          {theme === "dark" ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
          {theme === "dark" ? "Light" : "Dark"}
        </button>
        {user?.role === "superadmin" && (
          <button
            onClick={() => navigate("/superadmin/dashboard")}
            data-testid="sidebar-superadmin-btn"
            className="flex items-center gap-1 text-red-400 hover:text-red-300 transition-colors"
          >
            <Shield className="w-3.5 h-3.5" />
            Admin
          </button>
        )}
        <button
          onClick={onLogout}
          data-testid="logout-btn"
          className={`flex items-center gap-1 ${theme === "light" ? "hover:text-gray-900" : "hover:text-white"} transition-colors`}
        >
          <LogOut className="w-3.5 h-3.5" />
          Sign Out
        </button>
      </div>
    </div>
  );
}
